import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var media_type = 'fb'
if (instagram_addon) media_type = 'ig'
var http_api_create = window.xitFlowBuilderData.base_url+'http_api/build_api?channel='+media_type

export const httpApiHtml =

'<div class="text-left d-block">' +
  '<div class="form-group pb-3">' +        
    '<label class="pb-1 control-label">' + lang.http_api_list + '</label>' +
    '<select id="http-api-table-id" class="form-control select2"></select>' +
  '</div>' +
'</div>' +
'<div class="text-center">' +
  '<a class="btn btn-outline-primary" id="http-api-create-link" href="'+http_api_create+'" target="_BLANK"><i class="fas fa-plus-circle"></i> ' + lang.http_api_create + '</a> ' +
  '<a class="btn btn-outline-warning" id="http-api-edit-link" href="" target="_BLANK"><i class="fas fa-edit"></i> ' + lang.http_api_edit + '</a> ' +
  '<a class="btn btn-outline-success" id="http-api-report-link" href="" target="_BLANK"><i class="fas fa-eye"></i> ' + lang.http_api_report + '</a> ' +
  '<button type="button" id="refresh-list" class="btn btn-outline-info"><i class="fas fa-refresh"></i> ' + lang.http_api_refresh + '</button>' +
'</div>'
